import styled from 'styled-components';

const FILTER_HEADER_BG = '#F1F3F5';

export const AvatarFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.$white};
  background: ${({ theme }) => theme.$gray200};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
  overflow: hidden;
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const AvatarIcon = styled.i`
  font-size: 34px;
`;

export const FilterCard = styled.div`
  border: 1px solid ${({ theme }) => theme.$gray300};
  border-radius: 6px;
  overflow: hidden;
`;

export const FilterHeader = styled.div`
  background: ${FILTER_HEADER_BG};
  padding: 0.5rem 1rem;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const Chevron = styled.i<{ $isOpen: boolean }>`
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  color: ${({ theme }) => theme.$gray600};
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.$gray200};

  &:last-child {
    border-bottom: 0;
  }
`;

export const FilterStatus = styled.span`
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
`;

export const FilterEmpty = styled.p`
  font-size: 13px;
  margin: 0;
  padding: 1rem;
`;

export const FieldLabel = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.$gray600};
`;

export const FieldValue = styled.div`
  font-weight: 500;
`;

export const StatusBadge = styled.span`
  padding: 6px 10px;
  border-radius: 20px;
`;

export const Hint = styled.div`
  font-size: 12px;
`;

export const ButtonIcon = styled.i`
  font-size: 18px;
`;

export const AlertIcon = styled.i`
  font-size: 20px;
`;
